import { render, staticRenderFns } from "./ReportPreview.vue?vue&type=template&id=0855ef84&scoped=true"
import script from "./ReportPreview.vue?vue&type=script&lang=js"
export * from "./ReportPreview.vue?vue&type=script&lang=js"
import style0 from "./ReportPreview.vue?vue&type=style&index=0&id=0855ef84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0855ef84",
  null
  
)

export default component.exports